// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"28393726","133":"9f7e35c3","164":"3d551eb3","332":"61829a17","398":"11636798","401":"2103f359","413":"19dde9db","453":"b5312ed8","500":"384c908b","515":"57c13f0a","547":"95af96eb","812":"7ad41879","949":"b1383caf","954":"28333fef"}[chunkId] + ".chunk.js";
};